export const getPlaceholderOption = placeholder => ({
  label: placeholder,
  value: placeholder,
  disabled: true
});
